import Web3 from 'web3';

const getWeb3 = async () => {
 
  // Wait for loading completion to avoid race conditions with web3 injection timing.
  // window.addEventListener('load', async () => {
  // Modern dapp browsers...
  if (window.ethereum) {
    const web3 = await new Web3(window.ethereum);
    try {
      // Request account access if needed
      await window.ethereum.enable();
      // Acccounts now exposed
    } catch (error) {
      throw new Error(error.message);
    }
    return web3;
  }
  // Legacy dapp browsers...
  else if (window.web3) {
    // Use Mist/MetaMask's provider.
    const web3 = await window.web3;
    // eslint-disable-next-line no-console
    console.log('Injected web3 detected.');
    return web3;
  }
  // Fallback to localhost; use dev console port by default...
  else {
    // eslint-disable-next-line no-console
    console.log('install');
    throw new Error ('No web3 instance injected.');
  }
  // });
};

export default getWeb3;